<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="1100" persistent scrollable>
      <v-card class="vp-card">
        <v-card-title class="vp-hero py-3">
          <div class="d-flex align-center justify-space-between" style="width: 100%;">
            <div class="d-flex align-center" style="gap: 12px;">
              <v-avatar color="white" size="40" class="elevation-1">
                <v-icon color="teal darken-3">mdi-account-group-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 white--text">Inscritos por programa ESAM</div>
                <div class="text-body-2 white--text">
                  Consulta la cantidad de inscritos en cada sede
                </div>
              </div>
            </div>
            <v-chip color="teal lighten-5" class="teal--text text--darken-3" small>
              {{ registros.length }} registros
            </v-chip>
          </div>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="error" dense outlined v-if="error">
            {{ error }}
          </v-alert>

          <!-- <v-fade-transition v-if="loading">
            <div>
              <v-progress-linear indeterminate color="primary" class="mb-3" />
              <v-skeleton-loader type="table" />
            </div>
          </v-fade-transition> -->

          <v-fade-transition>
            <v-progress-linear v-if="loading" indeterminate color="blue" />

            <v-data-table 
              :headers="headers"
              :items="registros"
              dense
              disable-pagination
              hide-default-footer
              class="elevation-1"
              no-data-text="No se encontraron inscritos"
            >
              <template v-slot:item.cantidadInscritos="{ item }">
                <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3">
                  {{ item.cantidadInscritos }}
                </v-chip>
              </template>
              <template v-slot:item.fase="{ item }">
                <v-chip
                  x-small
                  :color="xcoloresFase[item.fase] || 'grey lighten-1'"
                  :dark="!!xcoloresFase[item.fase]"
                >
                  {{ xfases[item.fase] || 'DESCONOCIDO' }}
                </v-chip>
              </template>
              <!--  -->
              <template v-slot:item.modulo="{ item }">
                <template v-if="item.ultimoProgramaModuloConInscripciones">
                  <span> MOD {{ item.ultimoProgramaModuloConInscripciones.numero }}: </span>
                  <span> {{ item.ultimoProgramaModuloConInscripciones.modulo.nombre }} </span>
                </template>
                <template v-else>
                  <span>-</span>
                </template>
              </template>
            </v-data-table>
          </v-fade-transition>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { FASES_PROGRAMA } from '../../pagos/utils/constantes';
import ProgramaUniversidadService from '@/views/pagos/services/programa-universidad.service';

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      error: null,
      registros: [], 
      xfases: FASES_PROGRAMA,
      xcoloresFase: {
        0: 'grey',
        1: 'blue lighten-2',
        2: 'teal lighten-1',
        3: 'green',
        4: 'amber darken-1',
        5: 'indigo lighten-1',
        6: 'deep-purple lighten-1',
        7: 'orange darken-2',
        8: 'purple lighten-1',
        9: 'cyan darken-1',
        10: 'red lighten-1',
      },
      headers: [
        { text: 'Sede', value: 'sede.nombre' },
        { text: 'Programa', value: 'nombreCompuesto' },
        { text: 'Código', value: 'codigo' },
        // { text: 'Inscritos', value: 'cantidadInscritos' },
        { text: 'Gestión', value: 'gestion' },
        { text: 'Grupo', value: 'grupo' },
        { text: 'Fase', value: 'fase', },
        { text: 'Modulo en curso', value: 'modulo' },
      ],
    };
  },
  methods: {
    async openmodal(item) {
      window.console.log('itemprogsss',item);
        
      this.dialog = true;
      this.error = null;
      this.registros = []; 
      this.get_programa_universidad(item);
      await this.cargarInscritos(item);
    },
    async get_programa_universidad(item){
      this.loading = true
      const opciones = { params:{busqueda: item.codigo} }
      const r = await ProgramaUniversidadService.findAllPaginado(opciones)
      this.loading = false
      // window.console.log('rrrrrrrrrrr',r);
      if(r && r.data && r.data.datos){
        const ds = r.data.datos;
        const p = ds.find(x=>x.programaNombre == item.programaNombre )
        // window.console.log('rrrrrrrrrrr',p);
        if(p) this.cargarInscritos(p);

      }
      
    },
    cerrar() {
      this.dialog = false;
    },
    async cargarInscritos(item) {
      this.registros = item.programas
    },
  },
};
</script>

<style scoped>
.vp-card {
  border-radius: 14px;
  overflow: hidden;
}
.vp-hero {
  background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
}
</style>
